<template>
  <HeaderHome v-if="!$route.meta.hideLayout" />

  <div class="page-content">
    <router-view />
  </div>
   <FooterHome v-if="!$route.meta.hideLayout" />
</template>

<script setup>
import HeaderHome from "@/components/HeaderHome.vue"
import FooterHome from "@/components/FooterHome.vue";
</script>

<style>
@charset "UTF-8";

@import url("https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Cinzel:wght@400..900&family=Roboto:ital,wght@0,100..900;1,100..900&display=swap");

@font-face {
  font-family: "Exo_2";
  src: url("/src/assets/fonts/Exo_2/Exo2-Regular.ttf") format("truetype");
}

@font-face {
  font-family: "Orbitron";
  src: url("/src/assets/fonts/Orbitron/Orbitron-Black.ttf") format("truetype");
}

@font-face {
  font-family: "Bebas Neue";
  src: url("@/assets/fonts/Bebas_Neue/BebasNeue-Regular.ttf") format("truetype");
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Roboto";
  src: url("@/assets/fonts/Roboto/Roboto-Regular.ttf") format("truetype");
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Roboto";
  src: url("@/assets/fonts/Roboto/Roboto-SemiBold.ttf") format("truetype");
  font-weight: 600;
  font-style: normal;
  font-display: swap;
}

:root {
  --cor-texto-principal: #ffffff;
  --cor-texto-secundario: #B4ACC9;
  --cor-texto-suave: #8E85A6;

  --bg-primario: #150D29;
  --bg-secundario: #1F1437;
  --bg-destaque: #271A41;
  --bg-header: #110923;

  --card-base: #330977;
  --card-secundaria: #431491;
  --card-destaque: #7A33B6;
  --card-sombra: rgba(122, 51, 182, 0.35);
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  scrollbar-width: thin;
  scrollbar-color: var(--card-destaque) var(--bg-secundario);
}

html,
body {
  font-family: "Exo_2", Arial, sans-serif;
  background: var(--bg-primario);
  color: var(--cor-texto-principal);
  overflow-x: hidden;
  scroll-behavior: smooth;
}

h1,
h2 {
  letter-spacing: 2px;
}

h3,
h4,
p,
a,
span,
link {
  letter-spacing: 1px;
  line-height: 1.2;
}

.font-orbitron {
  font-family: "Orbitron", Arial, sans-serif;
}
.container {
  width: 100%;
  max-width: 1300px;
  margin: 0 auto;
}

@keyframes float {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-20px);
  }
}

@keyframes pulse-border {
  0%, 100% {
    border-color: var(--card-destaque);
  }
  50% {
    border-color: var(--card-secundaria);
  }
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.animate-slide-in {
  animation: slideIn 0.8s ease-out forwards;
}

.delay-100 { animation-delay: 0.1s; }
.delay-200 { animation-delay: 0.2s; }
.delay-300 { animation-delay: 0.3s; }
.delay-400 { animation-delay: 0.4s; }

.gradient-text {
  background: linear-gradient(135deg, #7A33B6, #431491, #7A33B6);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.carousel {
  --vc-pgn-background-color: #ffffff4a;
  --vc-pgn-active-color: var(--card-destaque);
  --vc-pgn-border-radius: 10px;
  --vc-pgn-height: clamp(6px, 1vw, 10px);
  --vc-pgn-width: clamp(6px, 1vw, 10px);

  --vc-nav-background: var(--card-sombra);
  --vc-nav-color: var(--cor-texto);
  --vc-nav-background-hover: var(--card-destaque);
  --vc-nav-color-hover: var(--card-destaque);
  --vc-nav-border-radius: 50%;
  --vc-nav-width: clamp(10px, 5vw, 30px);
  --vc-nav-height: clamp(10px, 5vw, 30px);
}

.carousel__viewport {
  margin: 0 clamp(10px, 6vw, 50px);
}

</style>
